// Push Notifications Utility
// This file handles Web Push API subscriptions

export const requestNotificationPermission = async (token) => {
  if (!('Notification' in window)) {
    console.log('Browser does not support notifications');
    return null;
  }

  if (!('serviceWorker' in navigator)) {
    console.log('Service workers not supported');
    return null;
  }

  // Check current permission
  if (Notification.permission === 'denied') {
    console.log('Notifications are blocked');
    return null;
  }

  // If already granted, just return
  if (Notification.permission === 'granted') {
    console.log('Notifications already enabled');
    return true;
  }

  // Request permission
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      console.log('Notification permission granted');
      return true;
    } else {
      console.log('Notification permission denied');
      return false;
    }
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

export const showBrowserNotification = (title, options = {}) => {
  if (Notification.permission === 'granted') {
    new Notification(title, {
      icon: '/butler-icon.png',
      badge: '/butler-badge.png',
      ...options
    });
  }
};

// Simple notification helper (doesn't use service workers)
export const initSimpleNotifications = async () => {
  const permission = await requestNotificationPermission();
  return permission;
};

export const notifyNewMessage = (senderName, preview) => {
  showBrowserNotification(`New message from ${senderName}`, {
    body: preview,
    tag: 'chat-message',
    requireInteraction: false
  });
};

export const notifyNewJob = (jobType, location) => {
  showBrowserNotification('New Job Available!', {
    body: `${jobType} at ${location}`,
    tag: 'new-job',
    requireInteraction: true
  });
};

export const notifyJobAssigned = (jobType, date) => {
  showBrowserNotification('Job Assigned to You!', {
    body: `${jobType} on ${date}`,
    tag: 'job-assigned',
    requireInteraction: true
  });
};